// extracted by mini-css-extract-plugin
export default {"subtitleText":"HomePage_subtitleText__-dByE"};